import { media, styled } from '@styles';
import { Container as DefaultContainer } from '@components/templates/Container';
import { prismicRichText } from '@styles/utils';

export const Wrapper = styled.div`
  padding: 2em 2em;
`;

export const Container = styled(DefaultContainer)<{
  reverse: boolean;
}>`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'row' : 'row-reverse')};
  justify-content: space-between;
  align-items: center;
  ${media.smallScreen`
    flex-direction: column;
  `}
  overflow: hidden;
`;

export const Paragraph = styled.div<{
  width: string | number;
}>`
  padding: 2em 2em;
  width: ${({ width }) => `calc(100% - ${width}%)`};
  ${media.smallScreen`
    width: 100%;
  `}
`;

export const Content = styled.div`
  ${prismicRichText}
  img {
    width: 100%;
  }
`;

export const Photo = styled.div<{ width: string | number }>`
  width: ${({ width }) => `calc(${width}%)`};
  height: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  ${media.smallScreen`
    width: 100%;
  `}
`;
